export const convertToUtcDate = date => {
  if (date) {
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
  }
  return undefined;
};
import moment from 'moment';
const convertUTCDateToLocalDate = str => {
  if (str) {
    const localDate = new Date(moment.utc(str).local());
    return localDate;
  }
  return null;
};

const formatDateddMMyyyy = date => {
  if (date) {
    return moment(date).format('DD/MM/yyyy');
  }
  return date;
};

const formatDateMMDDyyyy = date => {
  if (date) {
    return moment(date).format('MM/DD/yyyy');
  }
  return date;
};

const getMondayOfIsoWeek = (year, weekNumber) => {
  const jan4 = new Date(year, 0, 4);
  const firstMonday = new Date(jan4);
  firstMonday.setDate(jan4.getDate() - (jan4.getDay() === 0 ? 6 : jan4.getDay() - 1));
  const monday = new Date(firstMonday);
  monday.setDate(firstMonday.getDate() + (weekNumber - 1) * 7);
  return monday;
};

const getIsoWeekNumber = (date) => {
  const jan4 = new Date(date.getFullYear(), 0, 4);
  const firstMonday = new Date(jan4);
  firstMonday.setDate(jan4.getDate() - (jan4.getDay() === 0 ? 6 : jan4.getDay() - 1));
  const diffDays = Math.round((date - firstMonday) / (1000 * 60 * 60 * 24));
  return Math.floor(diffDays / 7) + 1;
};


export { convertUTCDateToLocalDate, formatDateddMMyyyy, formatDateMMDDyyyy, getMondayOfIsoWeek, getIsoWeekNumber};
